export default __webpack_public_path__ + "static/media/SavedSearches.c653900d.md";